import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { FormValidationService } from 'src/app/services/form-validation.service';
import { NavigatorService } from 'src/app/services/navigator.service';
import { UserDataService } from 'src/app/services/user-data.service';
import { PasswordRequirementsDialogComponent } from '../common/password-requirements-dialog/password-requirements-dialog.component';
import { StateService } from 'src/app/services/state.service';
import { InfoDialogComponent } from '../common/info-dialog/info-dialog.component';

@Component({
  selector: 'app-initial-data',
  templateUrl: './initial-data.component.html',
  styleUrls: ['./initial-data.component.css']
})
export class InitialDataComponent {

  voivodeships: string[] = [
    'Dolnośląskie',
    'Kujawsko-Pomorskie',
    'Lubelskie',
    'Lubuskie',
    'Łódzkie',
    'Małopolskie',
    'Mazowieckie',
    'Opolskie',
    'Podkarpackie',
    'Podlaskie',
    'Pomorskie',
    'Śląskie',
    'Świętokrzyskie',
    'Warmińsko-mazurskie',
    'Wielkopolskie',
    'Zachodniopomorskie'
  ];

  public intialDataForm: UntypedFormGroup = this.buildInitialDataForm();
  public formSubmitted: boolean = false;
  public dataUpdateFailed: boolean = false;
  public isSpinnerVisible: boolean = false;
  public termsCheckbox: boolean = false;

  public get formControls() {
    return this.intialDataForm.controls;
  }

  public get currentUserEmailAddress() {
    return this.userDataService.currentUserEmail ?? '';
  }

  constructor(
    private userDataService: UserDataService,
    private dialog: MatDialog,
    private navigator: NavigatorService,
    private formBuilder: UntypedFormBuilder,
    private formValidation: FormValidationService,
    private stateService: StateService
  ) {
      this.intialDataForm = this.buildInitialDataForm();
  }

  public async confirm() : Promise<void> {
    this.formSubmitted = true;
    // Akceptacja regulaminu wymagana także w logice (nie tylko przez [disabled]
    // przycisku) — zabezpiecza przed submitem np. klawiszem Enter.
    if (!this.intialDataForm.invalid && this.termsCheckbox) {
      await this.executeDataUpdate();
    }
  }

  public openPasswordRequirementsDialog() : void {
    this.dialog.open(PasswordRequirementsDialogComponent);
  }

  private buildInitialDataForm() : UntypedFormGroup {
    return this.formBuilder.group({
      firstName: ['', this.formValidation.trimmedRequiredValidator()],
      lastName: ['', this.formValidation.trimmedRequiredValidator()],
      companyName: ['', this.formValidation.trimmedRequiredValidator()],
      phoneNumber: ['', this.formValidation.trimmedRequiredValidator(8)],
      street: [''],
      number: ['', this.formValidation.trimmedRequiredValidator()],
      postalCode: ['', this.formValidation.trimmedRequiredValidator()],
      city: ['', this.formValidation.trimmedRequiredValidator()],
      voivodeship: ['', this.formValidation.trimmedRequiredValidator()],
      password: ['', this.formValidation.passwordValidator()],
      password2: ['', this.formValidation.passwordValidator()]
    }, { validators: this.formValidation.passwordMatchValidator('password', 'password2')});
  }

  private async executeDataUpdate() : Promise<void> {
    this.isSpinnerVisible = true;
    try {
      const result = await this.userDataService.registerCurrentUser(
        this.userDataService.currentUserEmail ?? '',
        this.formControls.firstName.value ?? '',
        this.formControls.lastName.value ?? '',
        this.formControls.companyName.value ?? '',
        this.formControls.street.value ?? '',
        this.formControls.number.value ?? '',
        this.formControls.postalCode.value ?? '',
        this.formControls.city.value ?? '',
        this.formControls.voivodeship.value ?? '',
        this.formControls.phoneNumber.value ?? '',
        this.formControls.password.value
      );
      if (result.success) {
        this.stateService.setStateAirconditioners();
        this.redirectAfterSuccess();
      } else if (result.reason === 'reauth') {
        this.handleSessionExpired();
      } else {
        this.displayErrorInfo();
      }
    } catch (e) {
      console.warn(e);
      this.displayErrorInfo();
    }
    this.isSpinnerVisible = false;
  }

  private handleSessionExpired() : void {
    this.dialog.open(InfoDialogComponent, { disableClose: true, data: {
      title: 'Sesja wygasła',
      message: 'Twoja sesja wygasła. Zaloguj się ponownie, aby dokończyć rejestrację.',
      isErrorInfo: true,
      okFunc: async () => { await this.userDataService.signOut(true); }
    } });
  }

  private redirectAfterSuccess() : void {
    this.navigator.redirectToModuleSelectScreen();
  }

  private displayErrorInfo() : void {
    this.formSubmitted = false;
    this.dataUpdateFailed = true;
    setTimeout(() => {
      this.dataUpdateFailed = false;
    }, 5000);
  }

  downloadAirConditionersPdf(){
    const pdfUrl = `assets/statutes/regulamin_promocji_klimatyzacja.pdf`; // Ścieżka do pliku PDF w katalogu assets
    const a = document.createElement('a');
    a.href = pdfUrl;
    a.download = 'regulamin_promocji_klimatyzacja.pdf';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  downloadPumpsPdf(){
    const pdfUrl = `assets/statutes/regulamin_promocji_pomp_ciepła.pdf`; // Ścieżka do pliku PDF w katalogu assets
    const a = document.createElement('a');
    a.href = pdfUrl;
    a.download = 'regulamin_promocji_pomp_ciepła.pdf';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  toggleTermsCheckbox(event: Event){
    const checked = (event.target as HTMLInputElement).checked;
    this.termsCheckbox = checked;
  }
}
